export default __webpack_public_path__ + "static/media/clock.9ef8301d.wav";